export const NATURES = ['view', 'click', 'try'];

/**
 * Required properties per event nature.
 * Keys with array values validate against that set.
 * Keys with null value require presence only (free-form).
 */
export const REQUIRED_PROPERTIES = {
  view: {
    type: ['screen', 'component', 'modal', 'banner'],
    source_type: [
      'navigation',
      'scroll',
      'push',
      'deep_link',
      'system',
      'interaction',
    ],
  },
  click: {},
  try: {
    source_type: ['user', 'system'],
    status: ['success', 'error', 'pending'],
  },
};

/**
 * Optional properties per event nature.
 * Same format as REQUIRED_PROPERTIES but only validated when present.
 * Enum values are checked if the property is passed; missing is fine.
 */
export const OPTIONAL_PROPERTIES = {
  view: {
    source_value: null,
  },
  click: {
    source_type: ['navigation', 'interaction'],
    source_value: null,
    option: null,
  },
  try: {
    option: null,
  },
};

/**
 * Properties that are conditionally required.
 * Format: { nature: { property: { when: { field, value } } } }
 */
export const CONDITIONAL_PROPERTIES = {
  try: {
    message: { when: { field: 'status', value: 'error' } },
  },
};
